<template>
  <el-dialog
    v-if="visibles"
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    top="8vh"
    width="40%"
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :icon="'icon-charge-detail'"
      :title="$t('shop.detailTitle')"
      @close="closeDialog"
    />
    <vue-linetitle
    :title="$t('shop.baseMessage')"
    :icon-config="{icon: 'car2-no'}">
      <el-form
        ref="formLeft"
        :model="formInfo"
        :label-position="'right'"
        :label-width="$t('shop.formLeftWidth')"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('shop.shopname')+'：'" prop="faultCode">
              {{ formInfo.shopName }}
            </el-form-item>
            <el-form-item :label="$t('shop.contacts')+'：'" prop="faultName">
              {{ formInfo.contactPeople }}
            </el-form-item>
            <el-form-item :label="$t('public.mobile')+'：'" prop="faultName">
              {{ formInfo.mobile }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-image 
              class="logo-img"
              :src="logoUrl[0]"
              :preview-src-list="logoUrl">
            </el-image>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$t('shop.address')+'：'">
              {{ formInfo.shopAddress }}
            </el-form-item>
            <el-form-item :label="$t('shop.shopLink')+'：'">
              <a :href="formInfo.shopLink" target="_blank" style="color:#409eff">{{ formInfo.shopLink }}</a>
            </el-form-item>
            <el-form-item :label="$t('shop.shoptime')+'：'" prop="faultName">
              {{ formInfo.businessTime }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </vue-linetitle>
    <vue-linetitle
      :title="$t('shop.otherMessage')"
      :icon-config="{icon: 'car-other'}">
      <el-form
        ref="formDetail"
        :model="formInfo"
        :label-position="'right'"
        :label-width="$t('shop.formDetailWidth')"
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <div style="margin-bottom:10px;">{{ $t('shop.jianjie') }}：</div>
          </el-col>
          <el-col :span="24">
            <div v-html="formInfo.introduction" />
          </el-col>
        </el-row>
      </el-form>
    </vue-linetitle>
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
// import { getDetail } from '@/api/userCenter/shop'
export default {
  name: 'DetailDialog',
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formInfo: {},
      logoUrl:[],
    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.formInfo = { ...this.data }
        this.logoUrl[0] = this.formInfo.logoUrl
      }
    }
  },
  created() {
  },
  methods: {
    // 关闭
    closeDialog() {
      this.$emit('update:visibles', false)
    },
    // 取消
    handleCancel() {
      this.closeDialog()
    }
  }
}
</script>
<style lang="scss" scoped>
.logo-img{
  width:127px;
  height: 132px;
  margin-left: 80px;
  img{
    width:127px;
    height: 132px;
  }
}
</style>
